export enum DownsamplingChoices {
    ALL = "all",
    SAMPLE = "sample",
};